{
	"title": "Skapa deklaration",
	"backLinkToMaterialDetailsTitle": "Tillbaka till materialdetaljer",
	"backLinkToMaterialDetailsWithDescriptionTitle": "Tillbaka till {{materialDescription}}",
	"backLinkToManageDeclarationsTitle": "Tillbaka till Hantera deklarationer",
	"steps": {
		"firstStep": {
			"title": "Steg 1",
			"label": "1"
		},
		"secondStep": {
			"title": "Steg 2",
			"label": "2"
		},
		"thirdStep": {
			"title": "Steg 3",
			"label": "3"
		}
	}
}
